import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetcher } from "@/shared/core-configs";
import { API } from "@/config";
import { ActivityLabelFormInput } from "../components/UpdateActivityLabelModal";
import {
  ActivityLabel,
  GET_ACTIVITY_LABELS_FETCH_KEY,
} from "@/shared/core-activity-labels";

export const updateActivityLabel = async (
  id: string,
  updatedActivityLabel: ActivityLabelFormInput,
): Promise<ActivityLabel> => {
  const response = await fetcher.patch<ActivityLabel>(
    `${API.GESLUB}/zone-activity-label/${id}`,
    updatedActivityLabel,
  );
  return response.data;
};

export const useUpdateActivityLabel = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation<
    ActivityLabel,
    Error,
    { id: string; updatedActivityLabel: ActivityLabelFormInput }
  >({
    mutationFn: async ({ id, updatedActivityLabel }) => {
      return updateActivityLabel(id, updatedActivityLabel);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GET_ACTIVITY_LABELS_FETCH_KEY],
      });
    },
  });

  return {
    mutate: mutation.mutate,
    isPending: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
  };
};
